const cloneDeep = require('lodash.clonedeep');
const plugin = {};

plugin.install = function (Vue, options) {

  Vue.cloneDeep = cloneDeep;
};

export default  plugin;
